module.exports = __webpack_public_path__ + "img/usd-level-2.30061974.webp";